import { AddressComponent, AutoCompleteAddress, AutoCompleteResponse } from '@bringg/types';
import axios from 'axios';

import { RANDOM_ADDRESS_RADIUS } from 'Consts';
import { getAdminApiEndpoint, getDashboardSdk } from '../helpers';

export async function getRandomAddresses(address: string): Promise<AddressComponent[]> {
  const endpoint = getAdminApiEndpoint(await getDashboardSdk());
  const addresses = await getAutoCompleteAddresses(address);
  const { address_details } = (
    await axios.post(`${endpoint}/api/geocoder/place_details`, { place_id: addresses[0].place_id })
  ).data;

  const { lat, lng } = address_details;

  return (await axios.get(`${endpoint}/demo/addresses?lat=${lat}&lng=${lng}&radius=${RANDOM_ADDRESS_RADIUS}`)).data;
}

export async function getAutoCompleteAddresses(address: string): Promise<AutoCompleteAddress[]> {
  const endpoint = getAdminApiEndpoint(await getDashboardSdk());
  const { addresses }: AutoCompleteResponse = (await axios.post(`${endpoint}/api/geocoder/auto_complete`, { address }))
    .data;
  return addresses;
}
